var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutoSuggest',{staticClass:"mb-0",attrs:{"label":_vm.$t(
      '_android_competition_details_info_allowed_countries',
      'Allowed countries:'
    ),"disabled":_vm.isTournamentFieldDisabled('countries_restrictions'),"multiple":"","only-unique":"","source":_vm.suggestCountriesRequest,"name":"countryRestriction","placeholder":_vm.$$t('Add Countries...', 'country-restriction-placeholder'),"tooltip":_vm.$$t(
      'Only participants from listed country will be allowed to register',
      'country-restriction-tooltip'
    ),"display-property":"text"},model:{value:(_vm.countriesRestrictions),callback:function ($$v) {_vm.countriesRestrictions=$$v},expression:"countriesRestrictions"}})}
var staticRenderFns = []

export { render, staticRenderFns }